<div>
  @if (this.Mode === 'design') {
    <div>
      <mat-form-field appearance="outline" [floatLabel]="'always'" subscriptSizing="dynamic">
        <mat-label>{{this.DisplayName}}</mat-label>
        <textarea matInput
          placeholder="{{this.PlaceholderText}}"
          rows="{{this.FormField.displayRows}}"
        disabled>{{this.FormField.instructionsText}}</textarea>
      </mat-form-field>
    </div>
  }
</div>
